import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import Cal, { getCalApi } from "@calcom/embed-react";
import { trackEvent } from '../utils/analytics';
import '../styles/page-layout.css';

const BeratungsterminPage: React.FC = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({"namespace":"kostenfreies-erstgesprach","embedJsUrl":"https://book.stimm.digital/embed/embed.js"});
      cal("ui", {"cssVarsPerTheme":{"light":{"cal-brand":"#0A8370"},"dark":{"cal-brand":"#0A8370"}},"hideEventTypeDetails":false,"layout":"month_view","theme":"dark"});
      
      // Tracking für erfolgreiche Buchung
      cal("on", {
        action: "bookingSuccessful",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        callback: (e: any) => {
          trackEvent('Cal_Booking_Successful', { details: e.detail });
        }
      });
    })();
  }, []);

  return (
    <Layout showBreadcrumbs={true}>
      <div className="page-container">
        <div className="page-header">
            <span className="section-title">Lass uns quatschen</span>
            <h1>
              Termin vereinbaren
            </h1>
            <p>
              Such dir einfach einen Slot aus, der dir passt. Wir sprechen über deine Idee und wie wir dir helfen können. Kostenlos und unverbindlich.
            </p>
        </div>
        <div className="content-wrapper" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
            <Cal 
                namespace="kostenfreies-erstgesprach"
                calLink="henri/kostenfreies-erstgesprach"
                style={{width:"100%",height:"100%",overflow:"scroll", minHeight: "700px"}}
                config={{"layout":"month_view"}}
                calOrigin="https://book.stimm.digital"
                embedJsUrl="https://book.stimm.digital/embed/embed.js"
            />
        </div>
      </div>
    </Layout>
  );
};

export default BeratungsterminPage;
